import React from 'react';
import styled from 'App/styled';
import { CategoryFacet, CommonFacet } from '@nykaa/listing-shared/type/filter';
import { Filters } from 'types/filter';
import ComponentMap from './map';


const Wrapper = styled.ul`
  background: #fff;
  border-radius: 3px;
  list-style: none;
  overflow-x: hidden;
  overflow-y: overlay;
  max-height: 400px;
  padding-right: 17px;
`;


const Facets = (props: Filters) => {
  const { filter, handleFilterChange, activeFilters, ...rest } = props;
  const FacetComponent = ComponentMap.get(filter?.type);
  const onFilterChange = (changedData: CommonFacet | CategoryFacet) => {
    const { type, key, title } = filter || {};
    const filterData = {
      data: changedData,
      key,
      type,
      title,
    };
    handleFilterChange(filterData);
  };
  return (
    <Wrapper id="custom-scroll">
      <FacetComponent
        filterData={filter}
        activeFilters={activeFilters}
        handleFilterChange={onFilterChange}
        {...rest}
      />
    </Wrapper>
  );
};

export default Facets;
